import React, { Component } from 'react';
import {Paper, Grid, Typography, Button, IconButton, Tooltip, TextField} from '@material-ui/core';
import * as Gserv from '../services/GatewayService';
// import Settings from '@material-ui/icons/Settings';
import DatasheetView from './DatasheetView';
import moment from 'moment';
import { ThumbUpTwoTone, VisibilityRounded, UndoTwoTone, EditTwoTone, PageviewTwoTone, WarningOutlined } from '@material-ui/icons';
import XLSX from 'xlsx';
import ExcelLogo from '../assets/ExcelLogo';
import FilterBox from './FilterBox';

export default class AssessmentsForReview extends Component {

    constructor(props) {
        super(props);
        this.state = {
            error: false,
            error_message: '',
            querying: true,
            pending_assessments_array: [],
            create_assessment: false,
            assessment: {},
            show_assessment: false,
            data_points: [],
            fetching_preview: false,
            file_url: null,
            overriding: false,
            override_value: '',
            override_comment: '',
            writing: false,
            filtered_assessments_array: [],
            filter_applied: false,
            filter_obj: {},
            competency_header: ''
        }
        this.comment_pattern = new RegExp("^[a-zA-Z0-9 `'?,.;!]+$");
        this.percent_pattern = new RegExp("^[1-9][0-9]{0,2}[.]{0,1}[0-9]{0,2}$");


        this.datasheetFieldSpecs = [
            { field: 'approve', headerName: 'Approve',align:'center', width: 85, headerAlign: 'center',
            sortable: false,
            renderCell: (parms) => (
                <IconButton 
                    onClick={()=>this.approveAssessment(parms)} 
                >
                    <ThumbUpTwoTone color='primary'/>
                </IconButton>
            )},
            { field: 'view', headerName: 'View', width: 70, headerAlign: 'center', align:'center',sortable: false,
            renderCell: (parms) => (
                <IconButton 
                    onClick={()=>this.viewAssessment(parms)} 
                >
                    <VisibilityRounded/>
                </IconButton>
            )},
            { field: 'store_code', headerName: 'Branch', width: 110, align:'center',headerAlign:'center'},
            { field: 'region', headerName: 'Region', width: 110, align:'center',headerAlign:'center'},
            { field: 'assessee_id', headerName: 'Empl.#', width: 110, align:'center',headerAlign:'center'},
            { field: 'assessee', headerName: 'Assessee', width: 160},
            { field: 'reports_to_rom', headerName: 'Manager Code', width: 125, align:'center'},
            { field: 'assessor', headerName: 'Assessor', width: 160},
            { field: 'cycle_code', headerName: 'Cycle Code', width: 160},
            { field: 'assessment_template_id', headerName: 'Type', width: 90, align:'center',headerAlign:'center'},
            { field: 'assessment_type_id', headerName: 'By', align: 'center', headerAlign:'center', width: 80, sortable:false},
            { field: 'created', headerName: 'Created', headerAlign:'center', align:'center', width: 120},
            { field: 'key_datapoint_score', headerName: 'Score', headerAlign:'right',align:'right', width: 100, sortable:false},
            { field: 'key_datapoint_score_override', headerName: 'Override?', headerAlign:'right',align:'right', width: 100, sortable:false},
            { field: 'key_datapoint_out_of', headerName: 'Out Of', width: 100, headerAlign:'right',align:'right', sortable:false},
            { field: 'key_comment', headerName: 'Comment', width: 200, sortable:false},
            // { field: 'approved', headerName: 'Approved?', align: 'center',width: 100, sortable: false},
        ]
    }

    componentDidMount = () => {
        
        Gserv.sendCommand('query_assessments_for_review',this.props.gwt)
        .then(reply=>{
            // console.log('query_my_assessment_history reply :>> ', reply);
            if (reply.error){
                console.log('error on return from Gserv (query_assessments_for_review) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
            } else if (reply.Result!=="Success"&&reply.statusCode!==204){
                console.log('error on return from Gserv (query_assessments_for_review) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
            } else {
                
                //clean formats for display
                if (reply.Records){
                let record_array = reply.Records;
                    let created_date = null;
                    for (var i=0;i<record_array.length;i++){
                        created_date = new moment(record_array[i].created).format("YYYY-MM-DD");
                        record_array[i].created = created_date;
                        // record_array[i].approved = record_array[i].approved ? "YES" : "";
                    }
                }

                if (this.state.filter_applied){
                    this.setState({querying:false, pending_assessments_array:reply.Records?reply.Records : []});
                    if (!reply.Records) {this.setState({filtered_assessments_array:[]})}
                    this.applyFilter(this.state.filter_obj);
                } else {
                    this.setState({querying:false, pending_assessments_array:reply.Records?reply.Records : [], filtered_assessments_array:reply.Records?reply.Records : []});
                }

            }
        });
    };

    resetMe = () => {
        this.setState({error: false,error_message: '',querying: true, pending_assessments_array: [], assessment:{},show_assessment:false,fetching_preview:false, writing:false, data_points:[], overriding:false});
        this.componentDidMount();
    }

    approveAssessment = (record) => {
        // console.log('record :>> ', record);
        this.setState({querying:true});
        Gserv.sendCommand('approve_assessment',this.props.gwt,{
            assessment_key: record.id
        })
        .then(reply => {
            // console.log('delete reply :>> ', reply);
            if (reply.error){
                console.log('error on return from Gserv (approve_assessment) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
            } else if (reply.Result!=="Success"){
                console.log('error on return from Gserv (approve_assessment) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
            } else {
                this.resetMe();
            }
        });
    }

    approveAssessmentFromView = (key) => {
        // console.log('record :>> ', record);
        this.setState({querying:true});
        Gserv.sendCommand('approve_assessment',this.props.gwt,{
            assessment_key: key
        })
        .then(reply => {
            // console.log('delete reply :>> ', reply);
            if (reply.error){
                console.log('error on return from Gserv (approve_assessment) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
            } else if (reply.Result!=="Success"){
                console.log('error on return from Gserv (approve_assessment) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
            } else {
                this.resetMe();
            }
        });
    }

    viewAssessment = (record) => {
        // console.log('record :>> ', record);
        this.setState({
            assessment:record.row,
            querying:true,
            override_value:record.row.key_datapoint_score_override? record.row.key_datapoint_score_override : '',
            override_comment:record.row.override_comment? record.row.override_comment : '',
            show_assessment:true
        });
        Gserv.sendCommand('query_assessment_datapoints',this.props.gwt,{
            assessment_key: record.id
        })
        .then(reply => {
            // console.log('query datapoints reply :>> ', reply);
            if (reply.error){
                console.log('error on return from Gserv (query_assessment_datapoints) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
            } else if (reply.Result!=="Success"){
                console.log('error on return from Gserv (query_assessment_datapoints) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
            } else {
                this.setState({querying:false, data_points:reply.Records?reply.Records : [], fetching_preview: record.row.file_attachment_required!==0? true : false, competency_header: reply.Records? (reply.Records[0].narration? reply.Records[0].narration.split('|')[0] : ''): ''});

                if (record.row.file_attachment_required!==0){
                    //Fetch .pdf preview...
                    Gserv.sendCommand('fetch_assessment_file_url',this.props.gwt,{
                        attachment_name: record.row.attachment_name,
                        assessment_template_id: record.row.assessment_template_id
                    })
                    .then(reply => {
                        // console.log('fetch assessment file reply :>> ', reply);
                        if (reply.error){
                            console.log('error on return from Gserv (fetch_assessment_file_url) :>> ', reply);
                            this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
                        } else if (reply.Result!=="Success"){
                            console.log('error on return from Gserv (fetch_assessment_file_url) :>> ', reply);
                            this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
                        } else {
                            // console.log('fetch_assessment_file ok')
                            this.setState({file_url:reply.Url, fetching_preview:false});
                        }
                    });
            
                }

            }
        });

    }

    overrideAssessment = () => {
        this.setState({overriding:true});
    }

    openFile = () => {
        const newWindow = window.open(this.state.file_url, '_blank', 'noopener,noreferrer');
        if (newWindow) newWindow.opener = null
    }

    trimDecimal = (e) => {
        // console.log('blur')
        // console.log(e.target.value.substring(e.target.value.length-1));
        if (e.target.value.substring(e.target.value.length-1)==="."){
            this.setState({override_value:e.target.value.substring(0,e.target.value.length-1)});
        }
    }

    handleFieldChange = (e) => {
        switch (e.target.id) {

            case 'override':
                if (!e.target.value){
                    this.setState({override_value:""});
                } else if (this.percent_pattern.test(e.target.value)){
                    this.setState({override_value:e.target.value});
                }
            break;
        
            default:
            break;
        }
    }

    handleCommentChange = (e) => {
        // console.log('e.target.value :>> ', e.target.value);
        if (!e.target.value){
            this.setState({override_comment:"", has_comment:false});
        } else if (this.comment_pattern.test(e.target.value)&&(e.target.value.length<=500)){
            if (e.target.value.length>5){
                this.setState({override_comment:e.target.value});
            } else {
                this.setState({override_comment:e.target.value});
            }
        }
    }

    cancelOverride = () => {
        this.setState({override_value:this.state.assessment.key_datapoint_override?this.state.assessment.key_datapoint_override : '', override_comment: this.state.assessment.override_comment? this.state.assessment.override_comment : '', overriding:false});
    } 

    applyOverride = (op='apply') => {
        // console.log('record :>> ', record);
        this.setState({writing:true});
        Gserv.sendCommand('apply_override',this.props.gwt,{
            assessment_key: this.state.assessment.assessment_key,
            override_value: op==='clear'? null : this.state.override_value,
            override_comment: op==='clear'? null : this.state.override_comment
        })
        .then(reply => {
            // console.log('delete reply :>> ', reply);
            if (reply.error){
                console.log('error on return from Gserv (apply_override) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
            } else if (reply.Result!=="Success"){
                console.log('error on return from Gserv (apply_override) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
            } else {
                this.resetMe();
            }
        });
    }

    clearOverride = () => {
        this.applyOverride('clear');
    }

    handleFilterChange = (filterObj) => {
        // console.log('filterObj :>> ', filterObj);
        if (filterObj.type==='clear'){
            this.setState({filtered_assessments_array : this.state.pending_assessments_array, filter_obj: {}, filter_applied:false})
        } else {
            this.setState({filter_obj:filterObj});
            this.applyFilter(filterObj);
        }
    }

    applyFilter = (filterObj) => {
        if (this.state.pending_assessments_array.length > 0){
            let temp_array = [];
            switch (filterObj.type) {
                case 'name':
                    for (const record of this.state.pending_assessments_array){
                        if (record.assessee.includes(filterObj.search_string)){
                            temp_array.push(record);
                        }
                    }
                    break;

                case 'number':
                    for (const record of this.state.pending_assessments_array){
                        if (record.assessee_id.includes(filterObj.search_string)){
                            temp_array.push(record);
                        }
                    }
                    break;
 
                case 'rom':
                    for (const record of this.state.pending_assessments_array){
                        if (record.reports_to_rom.includes(filterObj.search_string)){
                            temp_array.push(record);
                        }
                    }
                    break;
            
                default:
                    break;
            }
            this.setState({filtered_assessments_array: temp_array, filter_applied:true});
        }
    }   

    exportMe = () => {
        // console.log('called exportMe...');
        if (this.state.filtered_assessments_array.length>0){
            const dateStr = new moment().format("YYYY-MM-DD");
            var ws = XLSX.utils.json_to_sheet(this.state.filtered_assessments_array);
            var wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, 'Pending Review ' + dateStr);
            //Write to browser
            XLSX.writeFile(wb,'TMS Export - Assessments Awaiting Approval as at ' + dateStr + '.xlsx');
        }
    }

    deleteAss = (record) => {
        // console.log('record :>> ', record);


        if (record.row.approved==="YES"){

            this.setState({error:true,error_message:'Unable to delete assessments which have already been approved.'});

        } else {

            this.setState({querying:true});
            Gserv.sendCommand('delete_assessment',this.props.gwt,{
                assessment_key: record.id
            })
            .then(reply => {
                // console.log('delete reply :>> ', reply);
                if (reply.error){
                    console.log('error on return from Gserv (delete_assessment) :>> ', reply);
                    this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
                } else if (reply.Result!=="Success"){
                    console.log('error on return from Gserv (delete_assessment) :>> ', reply);
                    this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
                } else {
                    this.setState({error:false,error_message:'',pending_assessments_array:[]});
                    this.componentDidMount();
                }
            });

        }

    }

    render() {
        const key_code = this.state.assessment.key_datapoint_code;
        return(
        <Grid
            container
            direction='column'
            justifyContent='flex-start'
            alignContent='flex-start'
            // style={{backgroundColor:'yellow'}}
        >
            {!this.state.show_assessment&&
            <Grid item>
            <Paper
                elevation={3}
                style={{
                    // backgroundColor:'yellow',
                    width:1310
                }}
            >

                <Grid
                    container
                    // style={{backgroundColor:'yellow'}}
                    justifyContent='center'
                    alignContent='center'
                >

                    <Grid item xs={4}>
                        <div style={{display:'flex', justifyContent:'space-evenly', alignItems:"center"}}>
                            <Tooltip title="Export to Excel">
                            <span>
                            <IconButton 
                                aria-label='Export to Excel'
                                onClick={this.exportMe}
                                disabled={this.state.filtered_assessments_array.length===0}
                            >
                                <ExcelLogo />
                            </IconButton>
                            </span>
                            </Tooltip>
                        </div>
                    </Grid>

                    <Grid item xs={4}>
                        <Typography
                            style={{padding:10}}
                        >
                            Assessments Awaiting Approval
                        </Typography>
                    </Grid>

                    <Grid item xs={4}>
                        <Grid 
                            container
                            alignItems='center'
                            justifyContent='space-evenly'
                            // style={{backgroundColor:'yellow'}}
                        >
                            <FilterBox
                                setParentFilter={this.handleFilterChange}
                                data_populated={this.state.pending_assessments_array.length>0? true : false}
                                filter_applied={this.state.filter_applied}
                                filter_obj={this.state.filter_obj}
                                show_hod_filter={true}
                                // show_branch_filter={true}
                                // show_cycle_filter={true}
                            />
                        </Grid>
                    </Grid>
                   
                </Grid>

                {/* Datagrid goes here */}
                <DatasheetView 
                    dataset={this.state.filtered_assessments_array}
                    fieldspecs={this.datasheetFieldSpecs}
                    delete={this.props.super_admin}
                    edit={false}
                    handleDelete={this.deleteAss}
                    handleEdit={null}
                    loading={this.state.querying}
                    deleteHeaderName={''}
                    pagesize={10}
                    height={500}
                />

            </Paper>
            </Grid>}

            {this.state.show_assessment&&
            <Grid item>
            <Paper
                elevation={3}
                style={{
                    // backgroundColor:'yellow',
                    width:1075,
                    paddingBottom:'15px'
                }}
            >

                <Paper
                    elevation={3}
                    style={{
                        // backgroundColor:'yellow',
                        width:1075,
                        // padding:15,
                    }}
                >
                    <Tooltip title="Back"><IconButton aria-label='Back' onClick={()=>this.setState({show_assessment:false,assessment:{},data_points:[], competency_header:''})}><UndoTwoTone /></IconButton></Tooltip>
                </Paper>

                <Typography
                    style={{borderWidth:'1px',borderStyle:'solid',padding:'10px'}}
                >
                    <strong>{this.state.assessment.assessment_template.toUpperCase()}</strong>
                    {this.state.competency_header&&<span> ({this.state.competency_header})</span>}
                    <br/>
                    
                    <b>{this.state.assessment.assessment_type}</b> assessment for <b>{this.state.assessment.assessee}</b> ({this.state.assessment.job_title}) for cycle <b>{this.state.assessment.cycle_code}</b>
                </Typography>

                <Grid container direction='row' justifyContent='center' alignItems='center'>  
                    <Grid item xs={8}>
                        <Grid 
                            container
                            direction='column' justifyContent='flex-start' alignItems='flex-start'
                            style={{paddingTop:'15px',paddingBottom:'15px',paddingLeft:'75px'}}
                        >
                            <Typography><u>Assessment Data Points</u></Typography>
                            {this.state.data_points.map(function(item, i){
                                if (item.comment) {
                                    return (<Typography key={item.datapoint_id}>{item.datapoint_code.replace(/_/g,' ')} : <b>{item.comment}</b></Typography>)
                                } else {
                                    // console.log('key_code :>> ', key_code);
                                    if (item.datapoint_code===key_code){
                                        return (<Typography color='primary' style={{backgroundColor:'#e6e7e8'}} key={item.datapoint_id}>{item.datapoint_code.replace(/_/g,' ')} : <b>{item.score}</b> out of {item.score_out_of}</Typography>)
                                    } else {
                                        return (
                                        <Typography key={item.datapoint_id} style={{textAlign:'left'}}>
                                            {/* More detail provided where item is a competency */}
                                            {item.narration&&
                                            <span><b>{item.narration.split('|')[1]}</b> : {item.narration.split('|')[2]}<br/></span>}

                                            {item.datapoint_code.replace(/_/g,' ')} : <b>{item.score}</b> out of {item.score_out_of}

                                            {/* More detail provided where item is a competency */}
                                            {item.narration&&
                                            <span><b>{item.score==='0.000'? " [ NOT YET COMPETENT ]" : (item.score==='1.000'? " [ COMPETENT ]" : " [ EXPERT ]") }</b></span>}
                                        
                                        </Typography>)
                                    }
                                }
                            })}
                            <br/>
                            <Typography>
                                Assessment created on {this.state.assessment.created} by {this.state.assessment.assessor} (#{this.state.assessment.assessor_id}) 
                            </Typography>
                        </Grid>
                    </Grid>

                    {this.state.assessment.key_datapoint_score_override&&!this.state.overriding&&        
                    <Grid item xs={6}>
                        <Grid 
                            container
                            direction='column' justifyContent='center' alignItems='center'
                            style={{paddingTop:'15px',paddingBottom:'15px',paddingLeft:'75px', paddingRight:'75px'}}
                        >
                            <div style={{borderWidth:'1px',borderStyle:'dashed', padding:'15px'}}>
                                <Typography>Admin Override Applied: </Typography>
                                <hr style={{width:'100%'}}/>

                                <Typography color='primary' style={{backgroundColor:'#e6e7e8'}}>{this.state.assessment.key_datapoint_code.replace(/_/g,' ')} : <b>{this.state.assessment.key_datapoint_score_override}</b> out of {this.state.assessment.key_datapoint_out_of}</Typography>

                                <Typography><b>Comment:</b> {this.state.assessment.override_comment}</Typography>
                            </div>
                           
                        </Grid>
                    </Grid>}

                    {this.state.overriding&&        
                    <Grid item xs={6}>
                        <Grid 
                            container
                            direction='column' justifyContent='center' alignItems='center'
                            style={{paddingTop:'15px',paddingBottom:'15px',paddingLeft:'75px', paddingRight:'75px'}}
                        >
                            <Typography>Admin Override for Main Score: </Typography>
                            <hr style={{width:'100%'}}/>

                            <TextField
                                id={'override'}
                                type={'text'}
                                fullWidth={false}
                                label={'New Score'}
                                // helperText={"Override Score"}
                                autoCapitalize='off'
                                autoComplete='off'
                                autoCorrect='off'
                                required={true}
                                onChange={this.handleFieldChange}
                                value={this.state.override_value}
                                disabled={this.writing}
                                variant='standard'
                                // error={this.state.error_kpi_score}
                                style={{width:'90px',justifySelf:'flex-start',alignSelf:'flex-start'}}
                                onBlur={this.trimDecimal}
                            />

                            <TextField
                                id={'comment'}
                                type={'text'}
                                fullWidth={true}
                                label={'Comment'}
                                inputProps={{maxLength:500,minLength:10}}
                                autoCapitalize='off'
                                autoComplete='off'
                                autoCorrect='off'
                                required={true}
                                onChange={this.handleCommentChange}
                                value={this.state.override_comment}
                                disabled={this.writing}
                                variant='standard'
                            />

                            <Grid container direction='row' justifyContent='space-evenly' style={{marginTop:'15px'}}>
                                
                                <Button variant='contained' color='primary' disabled={(!this.state.override_value||!this.state.override_comment)||this.state.writing} onClick={this.applyOverride}>Apply Override</Button>

                                <Button variant='contained' disabled={(!this.state.override_value&&!this.state.override_comment)||this.state.writing} onClick={this.clearOverride} >Clear Override</Button>
                                
                                <Button onClick={this.cancelOverride} disabled={this.state.writing}>Cancel</Button>

                            </Grid>

                            {this.state.assessment.assessment_template_id==="360"&&
                            <Typography><WarningOutlined/><i>Applying an admin override for the main score of a Leadership 360 assessment will not affect an individual 360 Leadership Report (since individual component scores are not adjusted). Only aggregated reporting will be affected.</i></Typography>}
                           
                        </Grid>
                    </Grid>}

                </Grid>

                <hr/>

                {(this.state.assessment.file_attachment_required!==0)&&!this.state.fetching_preview&&                
                <span><Tooltip title="Open File Attachment">    
                <IconButton 
                    onClick={()=>this.openFile()} 
                >
                    <PageviewTwoTone color='primary' fontSize="large"/>
                </IconButton>
                </Tooltip> &nbsp;&nbsp;&nbsp;</span>}

                <Tooltip title="Approve">    
                <span>
                <IconButton 
                    onClick={()=>this.approveAssessmentFromView(this.state.assessment.assessment_key)} 
                    disabled={this.state.overriding}
                >
                    <ThumbUpTwoTone color={this.state.overriding?'inherit' : 'primary'}/>
                </IconButton>
                </span>
                </Tooltip>

                &nbsp;&nbsp;&nbsp;    

                <Tooltip title="Edit / Override Overall Score">
                <span>
                <IconButton 
                    onClick={()=>this.overrideAssessment()}
                    disabled={this.state.overriding} 
                >
                    <EditTwoTone color={this.state.overriding?'inherit' : 'primary'}/>
                </IconButton>
                </span>
                </Tooltip>
            </Paper>
            </Grid>}



            <Grid item>
                <Typography color='secondary' style={{Width:1310,maxWidth:1310, textAlign:'center'}}>{this.state.error_message}</Typography>
                {this.state.error&&<Button color='primary' variant='outlined' onClick={this.resetMe}>Reset</Button>}
            </Grid>

        </Grid>
    )}
    
}